import { render } from "./B2BOverview.vue?vue&type=template&id=b265ff70"
import script from "./B2BOverview.vue?vue&type=script&lang=js"
export * from "./B2BOverview.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src804629530/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__